export const Props = () => ({
  //ID Подкаста
  idPodcast: {
    type: Number,
    required: true,
  },

  //Убрать кнопки перемотки
  isWithoutSkip: {
    type: Boolean,
    required: false,
  }
});